if(typeof xlsx === 'undefined') {var e = new Error("Cannot find module \"xlsx\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = xlsx;


//////////////////
// WEBPACK FOOTER
// external "xlsx"
// module id = 9208
// module chunks = 2